<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";

import Editor from "@/common/components/ContentEditor.vue";

const props = defineProps<{
  context: FormKitFrameworkContext;
}>();
</script>

<template>
  <Editor v-bind="props" />
</template>
